import { combineReducers } from 'redux';

import lead from './lead';

const rootLeadReducer = combineReducers({
  lead,
});

export default rootLeadReducer;
